import { observer } from 'mobx-react-lite';
import React from 'react';
import { withDefaultProps } from 'react-default-props-context';
import { SelfTestT } from 'src/api/types/SelfTestT';
import { cn } from 'src/frames/utils/cn';
import { DisclaimerView } from 'src/selfTest/components/DisclaimerView';
import './LandingView.scss';
import { trackEvent } from '../../tracking/utils/initTracking';
import {updateBCNHelper} from "../../ads/utils/initAds";

type PropsT = {
  className?: any;
};

type DefaultPropsT = {
  goToNextPage: () => void;
  selfTest: SelfTestT;
  selfTestRS: string;
};

export const LandingView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    const [showDisclaimer, setShowDisclaimer] = React.useState(false);

    if (props.selfTestRS !== 'success') {
      return <div></div>;
    }
    if (showDisclaimer) {
      return <DisclaimerView setShowDisclaimer={setShowDisclaimer} />;
    }
    return (
      <div className={cn('LandingView', 'flex flex-col', props.className)}>
        <div className="flex flex-row justify-center">
          <img
            alt=""
            src="landingImage.jpeg"
            className={cn('LandingView__Image', 'grow-0')}
          />
        </div>
        <div className={cn('LandingView__Card', 'px-4 py-8')}>
          <div className={cn('LandingView__Title', 'mt-4')}>
            {props.selfTest.frontendTitle}
          </div>
          <div className={cn('LandingView__Description', 'mt-2')}>
            {props.selfTest.description}
          </div>
          <button
            className={cn('LandingView__Button', 'mt-6')}
            onClick={() => {
              updateBCNHelper();
              trackEvent('click_start', 'General', props.selfTest.name);

              if (props.selfTest.disclaimer && props.selfTest.disclaimerTitle) {
                setShowDisclaimer(true);
              } else {
                props.goToNextPage();
              }
            }}
          >
            {props.selfTest.buttonText}
          </button>
        </div>
      </div>
    );
  })
);
